exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.news-list-item {\n    height: auto;\n}\na.v-btn:link {\n    color: black !important;\n}\n", ""]);

// exports
